import {withKnownRoute} from '../../lib/routes';
import {NamesPage} from './names-page';

export default withKnownRoute(NamesPage);
